module.exports = __webpack_public_path__ + "static/media/prepaid_b09.0a229be7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/prepaid_b09.png
// module id = 738
// module chunks = 21